const determinationReason = {
  Unsert: 0,
  ObjetadoPorEquipoComprado: 1,
  ObjetadoConCita: 2,
  ObjetadoConReferido: 3,
  AprobadoPorCSEE: 4,
  ApprovedByUnitDirector: 5,
  ObjetadoPorDirectorDeLaUnidad: 7,
  ObjectadoReferidoActivoEnAgencia: 21,
  AprobadoPorOrderDeJuez: 15,
  AprobadoPorDirectorDeLaUnidad: 5,
  ObjecionPorNoDisponibilidad: 16,
  AprobadoGeneral: 14,
  CanceladoOtros: 22,
  ObjetadoEstudianteenUbicacionUnilateral: 23,
  High: 24,
  Egress: 25,
  RejectOfCompensatoryServices: 26,
  RejectToReceiveServiceWithSAEE: 27,
  DuplicateService: 28,
  TransferByOffering: 29,
  ThereAuthorizedPositionBySAEE: 36,
  IrregularStaffApplicationProcess: 38,
  ApprovedByCompensatoryServices: 30,
  ApprovedByReConsiderations: 18,
  ReturnedToSAEEByHiringLack: 41
};

export default determinationReason;
